import styled from '@emotion/styled'

const Button = styled.div`
  background-color: rgba(46, 46, 46, 0.1);
  background-image: linear-gradient(180deg, #221c1c, #0e0202);
  padding: 20px;
  text-align: center;
  border: 1px solid rgba(255, 0, 0, 0.233);
  cursor: pointer;
  box-shadow: 0px 0px 10px black;
  transition: 0.3s;
  &:hover {
    border: 1px solid rgba(255, 0, 0, 0.233);
    box-shadow: 0px 0px 10px rgba(255, 0, 0, 0.433);
  }
`

export default Button;